import React from "react";
import { useLink, useGetIdentity } from "@refinedev/core";
import { theme, Space } from "antd";
import { RefineLayoutThemedTitleProps } from "@refinedev/antd";
import quixLogo from "assets/Logo.png";

const { useToken } = theme;

const defaultText = "Quix Quantum";

const defaultIcon = (
	<img src={quixLogo} alt="Quix Quantum" width={100}></img>
);
const collapsedIcon = (
	<img src={quixLogo} alt="Quix Quantum" width={100}></img>
);

export const CustomTitle: React.FC<RefineLayoutThemedTitleProps> = ({
	collapsed,
	icon = defaultIcon,
	text = defaultText,
	wrapperStyles,
}) => {
	const { token } = useToken();
	const Link = useLink();

	const { data: user } = useGetIdentity<{ role: { type: string }}>();

	const role = user?.role?.type;

	const getPath = () => {
		switch (role) {
			case "admin":
				return "/admin";
			case "external":
				return "/jobs";
			default:
				return "/";
		}
	}

	return (
		<Link
			to={getPath()}
			style={{
				display: "inline-block",
				textDecoration: "none",
			}}
		>
			<Space
				style={{
					display: "flex",
					alignItems: "center",
					fontSize: "inherit",
					...wrapperStyles,
				}}
			>
				{collapsed ? (
					<div
						style={{
							height: "60px",
							width: "117px",
							color: token.colorPrimary,
						}}
					>
						{collapsedIcon}
					</div>
				) : (
					<div
						style={{
							height: "60px",
							width: "117px",
							color: token.colorPrimary,
						}}
					>
						{icon}
					</div>
				)}
			</Space>
		</Link>
	);
};

